<template>
  <div class="dashboard-actual">
    <div class="dashboard-actual-header">
      <div class="dashboard-actual-header__left">
        <radio-group
          @on-change="changeMode"
          v-model="mode"
          size="small"
          type="button"
        >
          <radio v-for="(item, value) in modes" :key="item" :label="item">
            {{ value }}
          </radio>
        </radio-group>
        <span v-if="backgroundLoading" class="ms-help">
          Обновление списка задач...
        </span>
      </div>
      <div>
        <radio-group v-model="type" size="small" type="button">
          <radio v-for="(item, value) in types" :key="item" :label="item">
            {{ value }}
          </radio>
        </radio-group>
      </div>
    </div>
    <div class="dashboard-actual-container">
      <inline-loader v-if="loading" :loading="loading" />
      <router-view
        v-else
        :stickers="stickers"
        :tasks="tasks"
        :holidays="holidays"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import InlineLoader from '@/components/loaders/inline-loader'

const modes = {
  Обычный: 'common',
  Месяц: 'month',
  Неделя: 'week'
}
const types = {
  'Основные проекты': 'project',
  'Подрядчики': 'contragent'
}

export default {
  components: {
    InlineLoader
  },
  data () {
    return {
      stickers: [],
      tasks: [],
      holidays: [],
      loading: false,
      backgroundLoading: false,
      mode: 'common',
      type: 'project',
      modes,
      types
    }
  },
  watch: {
    '$store.state.socket': {
      handler: function (val) {
        if (!val.create && !val.update && !val.delete) return
        const { type } = this.$store.state.socket

        if (type === 'stickers') this.getStickers(true)

        this.$store.commit('CLEAR_SOCKET_STATE')
      },
      deep: true,
      immediate: true
    },
    '$route.path': function () {
      this.setModeValue()
    },
    '$store.state.dashboard.needToUpdate' (value) {
      if (value) {
        this.getTasks(true)
        this.$store.commit('SET_DASHBOARD_PROP', ['needToUpdate', false])
      }
    },
    type () {
      this.getTasks()
    }
  },
  methods: {
    changeMode (value) {
      this.$router.push(`/app/dashboard/actual/${value}`)
    },
    async getHolidays () {
      try {
        const url = `/page/this_year_holiday`
        this.holidays = await this.$store.dispatch('GET_REQUEST', { url })
      } catch (error) {
        console.log(error)
      }
    },
    async getStickers (noloading) {
      try {
        if (!noloading) this.stickersLoading = true
        const url = `page/stickers`
        this.stickers = await this.$store.dispatch('GET_REQUEST', { url })
      } catch (error) {
        console.log(error)
      }
    },
    async getTasks (noLoading) {
      try {
        if (!noLoading) this.loading = true
        else this.backgroundLoading = true

        let url = `page/workflow_task`

        if (this.type === 'contragent') {
          url += '?contragents=true'
        }

        this.tasks = await this.$store.dispatch('GET_REQUEST', { url })

        // set stats
        const expired = this.tasks.filter(({ expiration_date }) => {
          const diff = moment(expiration_date, 'YYYY-MM-DD').diff(
            moment(),
            'days'
          )

          return diff < 0
        })

        this.$store.commit('SET_DASHBOARD_PROP', [
          'allTasksCount',
          this.tasks.length
        ])
        this.$store.commit('SET_DASHBOARD_PROP', [
          'expiredTasksCount',
          expired.length
        ])

        this.loading = false
        this.backgroundLoading = false
      } catch (error) {
        console.log(error)
        this.loading = false
        this.backgroundLoading = false
      }
    },
    setModeValue () {
      const pathArray = this.$route.path.split('/')
      this.$set(this, 'mode', pathArray[pathArray.length - 1])
    }
  },
  created () {
    this.setModeValue()
    this.getHolidays()
    this.getStickers()
    this.getTasks()
  }
}
</script>

<style lang="less">
.dashboard-actual {
  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    &__left {
      display: flex;
      align-items: center;

      .ms-help {
        margin-left: 16px;
      }
    }

    .ivu-select {
      width: 220px;
    }
  }
}
</style>
